<template>
  <div>
    <PlatformDtHc
      ref="platform"
      :bridge="bridge"
      :localStoragePrefix="localStoragePrefix"
      :buttons="buttons"
      :outputs="outputs"
      :uarts="uarts"
      :leds="leds"
      :languages="languages"
      :vbusSpecifications="vbusSpecifications"
      @initialized="platformInitialized"
    ></PlatformDtHc>
  </div>
</template>

<script>
import { BasicPlatformWasiBridge } from '@/bridges/BasicPlatformWasiBridge';

import PlatformDtHc from '@/device-platforms/PlatformDtHc.vue';

const SpecificationFile = require('resol-vbus/src/specification-file');
const Specification = require('resol-vbus/src/specification');

export default {
  props: [
    'localStoragePrefix',
  ],

  components: {
    PlatformDtHc,
  },

  data: () => ({
    label: 'COSMO Multi 3 1.00',
    wasmUrl:'/11216175_COSMO_Multi_1d00_SNAPSHOT_DW_MC.wasm',
    wasmModule: null,
    bridge: null,
    vbusSpecifications: [],

    buttons: [
      { platformIndex: 0,conversion: 'resistorPt1000Temperature', value: null, initialValue: 12.3, name: 'S1', }, // Pt1000
      { platformIndex: 1,conversion: 'resistorPt1000Temperature', value: null, initialValue: 52.3, name: 'S2', }, // Pt1000
      { platformIndex: 2,conversion: 'resistorPt1000Temperature', value: null, initialValue: 62.3, name: 'S3', }, // Pt1000
      { platformIndex: 3,conversion: 'resistorPt1000Temperature', value: null, initialValue: 72.3, name: 'S4', }, // Pt1000
      { platformIndex: 4,conversion: 'resistorPt1000Temperature', value: null, initialValue: 12.3, name: 'S5', }, // Pt1000
      { platformIndex: 5,conversion: 'resistorPt1000Temperature', value: null, initialValue: 12.3, name: 'S6', }, // Pt1000
      { platformIndex: 6,conversion: 'resistorPt1000Temperature', value: null, initialValue: 12.3, name: 'S7', }, // Pt1000
      { platformIndex: 7,conversion: 'resistorPt1000Temperature', value: null, initialValue: 12.3, name: 'S8', }, // Pt1000
      // { platformIndex: 8,conversion: 'resistorPt1000Temperature', value: null, initialValue: 12.3, name: 'S9', }, // Pt1000 / V40
      // { platformIndex: 9,conversion: 'digitalState', value: null, initialValue: 0, name: 'S10', }, // CS10
    ],
    outputs: [
      { name: 'R1', conversion: 'dutycyclePercentIncorrectlyScaled', value: null }, // Relais
      { name: 'R2', conversion: 'dutycyclePercentIncorrectlyScaled', value: null }, // Relais
      { name: 'R3', conversion: 'dutycyclePercentIncorrectlyScaled', value: null }, // Relais
      { name: 'R4', conversion: 'dutycyclePercentIncorrectlyScaled', value: null }, // Relais
      { name: 'R5', conversion: 'dutycyclePercentIncorrectlyScaled', value: null }, // Relais
      { name: 'A1', conversion: 'dutycyclePercentIncorrectlyScaled', value: null }, // PWM / 0-10V
      { name: 'A2', conversion: 'dutycyclePercentIncorrectlyScaled', value: null }, // PWM / 0-10V
    ],

    leds: [
        { state: null }
    ],

    uarts: [
      { name: 'UART0', kind: 'VBus', label: 'GP' },
      { name: 'UART1', kind: 'VBus', label: 'ZA' },
    ],

    languages: [
      { value: 0, text: 'Deutsch', short: 'de' },
      { value: 1, text: 'English', short: 'en' },
    ],
  }),

  created() {
  },

  mounted() {
  },

  methods: {
    async prepareDevice() {
      const response = await fetch(this.wasmUrl);
      const wasmArrayBuffer = await response.arrayBuffer();
      // console.log(wasmArrayBuffer);

      this.wasmModule = await WebAssembly.compile(wasmArrayBuffer);
      // console.log(this.wasmModule);

      this.bridge = new BasicPlatformWasiBridge(this.wasmModule);
      await this.bridge.instantiate();

      this.$refs.platform.prepareBridgeable();

      const vsfResponse = await fetch('/vbus_specification.vsf');
      const vsfArrayBuffer = await vsfResponse.arrayBuffer();
      const vsfBuffer = Buffer.from(vsfArrayBuffer);
      const specificationFile = new SpecificationFile(vsfBuffer);
      const specification = new Specification({ specificationFile });
      this.vbusSpecifications.push(specification);
    },

    startDevice() {
      this.bridge.start();
    },

    restartDevice() {},

    platformInitialized() {
    },
  },
};
</script>

<style>

</style>
